module.exports = __webpack_public_path__ + "static/img/rt-ch_echarts.8000b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/classroomObservation/rt-ch_echarts.png
// module id = CV2s
// module chunks = 4